import useTranslate from '@root/core/hooks/useTranslate';
import wareHouseService from '@root/modules/Warehouse/Dasboard/services/warehouse';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import CardTotal from './cardTotal';

function WrapCardTotal() {
  const [t] = useTranslate();

  const [totalCard, setTotalCard] = useState([] as any);

  const getTotal = async () => {
    const warehouse = await wareHouseService.getTotalCard();
    if (warehouse.message == 'success') {
      setTotalCard(warehouse.data);
    }
  };

  useEffect(() => {
    getTotal();
  }, []);

  return (
    <div className="wrapCardTotal">
      <div className="site-card-wrapper">
        <Row gutter={16}>
          {totalCard.map((item: any, index: number) => (
            <>
              <Col span={3}>
                <CardTotal title={item.title} sum={item.amount} />
              </Col>
            </>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default WrapCardTotal;
